// GoogleMapWithMarker.jsx

// Import React
import * as React from 'react'
import { color } from "../config/color"
import store from "../config/config.json"
import { Text, View } from "react-native";
import Autocomplete from 'react-google-autocomplete';


// Import necessary components for React Google Maps
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from 'react-google-maps'

// Import custom styles to customize the style of Google Map
const styles = require('../assets/map.json')

// Import custom icon for map marker
// You can use this if you need to support IE11 and lower.
// const mapMarker = require('./GoogleMapMarker.svg')

// Google Map component
const GoogleMapComponentWithMarker = withScriptjs(
  withGoogleMap(props => (
    
      <GoogleMap
        ref={props.onMapLoad}
        onDragEnd={props.onDragEnd}
        defaultZoom={16}
        center={props.latlng}
        defaultCenter={props.latlng}
        defaultOptions={{
          disableDefaultUI: props.disableDefaultUI != undefined ? props.disableDefaultUI : false , // disable default map UI
          draggable: props.draggable, // make map draggable
          keyboardShortcuts: false, // disable keyboard shortcuts
          scaleControl: false, // allow scale controle
          scrollwheel: true, // allow scroll wheel
          styles: styles // change default map styles
        }}
      >

        { props.prepareHandler != undefined ? props.prepareHandler(props) : ""}
                
        { !props.disableMarker && (
          <Marker
              draggable={true}
              color={store.primaryColor}
              icon={{url:require('../assets/marker.png'),}}
              position={props.latlng}
            />
        )}

      </GoogleMap>
  ))
)

// Export Google Map component
export default GoogleMapComponentWithMarker